import { Button, Legacyprofile, RichText, Campaign, Blog, Publicprofile } from '@/payload-types'
import { format } from 'date-fns'

function getH2Titles(richText: RichText) {
  const h2List = richText?.richText?.root?.children.filter((child) =>
    typeof child === 'object' &&
    child.tag === 'h2' &&
    child.hasOwnProperty('children') &&
    Array.isArray(child.children) &&
    child.children.some((x) => x.hasOwnProperty('text')));


  if (h2List != undefined && h2List?.length > 0) {
    const titles = h2List.flatMap((item) => {
      if (typeof item === 'object' && item.hasOwnProperty('children')) {
        if (Array.isArray(item.children)) {
          return item.children.flatMap((x) => {
            if (x.hasOwnProperty('text')) {
              return x.text
            }
          })
        }
      }
    })
    return titles[0];
  }
}

export function CreateAnchorLink(item: RichText | string) {
  const title = typeof item === 'string' ? item : getH2Titles(item)

  if (title) {
    const href = title?.replace(/ /g, '-')
    const hrefLink = `#${href}`

    return { label: title ? title : '', href: hrefLink ? hrefLink : '' }
  } else {
    return null
  }
}

const monthAbbreviations: { [key: number]: string } = {
  0: 'Jan.',
  1: 'Feb.',
  2: 'Mar.',
  3: 'Apr.',
  4: 'May',
  5: 'Jun.',
  6: 'Jul.',
  7: 'Aug.',
  8: 'Sept.',
  9: 'Oct.',
  10: 'Nov.',
  11: 'Dec.'
};

export function profileformatDate(dateString: string): string {
  const date = new Date(dateString);
  const month = date.getMonth();
  const day = date.getDate();
  const year = date.getFullYear();

  const monthAbbr = monthAbbreviations[month];
  return `${monthAbbr} ${day}, ${year}`;
}
export function formatDate(dateString: string): string {
  return format(new Date(dateString), 'MMMM d, yyyy')
}

export function createProfilebutton(profile?: (string | null) | Legacyprofile | Publicprofile) {
  let button: Button | null | string = null
  if (typeof profile == 'object' && profile) {
    const name = 'profileEntity' in profile ? typeof profile.profileEntity == 'object' ? profile.profileEntity.fullName : '' : profile.fullName
    button = {
      id: profile?.id ? profile?.id : '',
      name: name ? name : '',
      label: 'See Profile',
      backgroundColor: 'gray-900',
      iconType: 'ArrowRight',
      updatedAt: '',
      createdAt: '',
    }
  }
  return button
}

export function checkIfHaveKeyProfiles(postData: Campaign | Blog | null) {
  let haveKeyProfile = false;
  postData?.block?.map((block) => {
    if (block.blockType === 'profileList') {
      block.profileList?.map((profile) => {
        if (profile.keyProfile === true) {
          haveKeyProfile = true;
          return haveKeyProfile;
        }
      })
    }
    else if (block.blockType === 'keyProfileList') {
      haveKeyProfile = true;
      return haveKeyProfile;
    }
  })
  return haveKeyProfile;
}